import { getIn, setIn } from './utils';

const START_LOADING = 'START_LOADING'; // { payload: { area: 'test'} }
const SET_AREA_DATA = 'SET_AREA_DATA';
const SET_AREA_ERROR = 'SET_AREA_ERROR';
const CLEAR_AREA = 'CLEAR_AREA';

export const START_AREAS_LOADING = 'START_LOADING'; // { payload: { area: 'test'} }
export const SET_AREAS_DATA = 'SET_AREA_DATA';
export const SET_AREAS_ERROR = 'SET_AREA_ERROR';
export const CLEAR_AREAS = 'CLEAR_AREA';

function hierarchyReducer(state, action) {
  switch (action.type) {
    case START_LOADING:
      return setIn(state, action.payload, {
        ...getIn(state, action.payload),
        loading: true,
        data: null,
        error: null,
      });

    case SET_AREA_DATA:
      return setIn(state, action.payload.name, {
        ...getIn(state, action.payload.name),
        loading: false,
        data: action.payload.value,
        error: null,
      });

    case SET_AREA_ERROR:
      return setIn(state, action.payload.name, {
        ...getIn(state, action.payload.name),
        loading: false,
        data: null,
        error: action.payload.value,
      });

    case CLEAR_AREA:
      const { data, loading, error, ...other } =
        getIn(state, action.payload) || {};
      return setIn(state, action.payload, other);

    default:
      return state;
  }
}

export default function(state, action) {
  switch (action.type) {
    case START_AREAS_LOADING:
      return action.payload.reduce(
        (m, payload) => hierarchyReducer(m, { type: START_LOADING, payload }),
        state
      );

    case SET_AREAS_DATA:
      return action.payload.reduce(
        (m, payload) => hierarchyReducer(m, { type: SET_AREA_DATA, payload }),
        { ...state }
      );

    case SET_AREAS_ERROR:
      return action.payload.reduce(
        (m, payload) => hierarchyReducer(m, { type: SET_AREA_ERROR, payload }),
        state
      );

    case CLEAR_AREAS:
      return action.payload.reduce(
        (m, payload) => hierarchyReducer(m, { type: CLEAR_AREA, payload }),
        state
      );

    default:
      return state;
  }
}
